import { render, staticRenderFns } from "./CancelRequest.vue?vue&type=template&id=2f118456&scoped=true&"
import script from "./CancelRequest.vue?vue&type=script&lang=js&"
export * from "./CancelRequest.vue?vue&type=script&lang=js&"
import style0 from "./CancelRequest.vue?vue&type=style&index=0&id=2f118456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f118456",
  null
  
)

export default component.exports